import React, { useEffect, useState, useRef, useMemo } from "react";
import SearchableSelect from "util/component/SearchableSelect";

import axios from 'util/axios';

import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

const Master = (props) => {
    const { data, funcs } = props;
    const sheetcd = useLocation().state;
    const dispatch = useDispatch();

    const [MasterOPTS, SetMasterOPTS] = useState({});
    const [MasterValue, SetMasterValue] = useState({});
    
    const getsheetinfo = async (sheetcd) => {
        const response = await axios
            .post(process.env.REACT_APP_API + "/diff/selectPcsSheetD", { sheetcd: sheetcd })
            .then((response) => response.data.data.result[0]);
        SetMasterValue({
            projectNm: response.projectNm,
            mbrNo: response.mbrNo,
            processCd: response.processCd,
        });
    };

    const initialOptions = async () => {
        dispatch({ type: "LOADING_ON" });
        let res;
        const GRCD = ["PROJECT", "MBRNO"];
        let newOPTS = {};
        try {
            for (let i of GRCD) {
                res = await axios.post(
                    process.env.REACT_APP_API + "/common/retrieveMasterCodeList",
                    {
                        grcd: i,
                        disableYn: "N",
                    }
                );
                newOPTS[i] = res.data.data.result;
            }
            SetMasterOPTS((OLD) => ({ ...OLD, ...newOPTS }));
        } catch (e) {}
        dispatch({ type: "LOADING_OFF" });
    };

    useEffect(() => {
        getsheetinfo(sheetcd);
        initialOptions();
    }, []);

    const HandleMasterValue = (selected, option) => {
        SetMasterValue((OLD) => ({ ...OLD, [option.name]: selected.value }));
    };

    useEffect(() => {
        let { projectNm, mbrNo, processCd } = MasterValue;

        if (!!projectNm && !!mbrNo && !!processCd) {
            funcs?.getSheetCd(MasterValue);
        } else {
            funcs?.changed();
        }
        return () => {};
    }, [MasterValue]);
    return (
        <div>
            <div className="info_top">
                <table id="head-table">
                    <colgroup>
                        <col width="100" />
                        <col width="100" />
                        <col width="100" />
                        <col width="100" />
                        <col width="350" />
                        <col />
                        <col width="80" />
                        <col width="120" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>Plant</th>
                            <th>Project</th>
                            <th>MBR No</th>
                            <th>Process</th>
                            <th>Unit Operation</th>
                            <th>Description</th>
                            <th>Cycle</th>
                            {/* <th>Stage</th> */}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{ backgroundColor: "#DDD" }}>{data?.plant}</td>
                            <td>
                                <SearchableSelect
                                    name="projectNm"
                                    // value={inputs.projectNm}
                                    search={true}
                                    options={MasterOPTS.PROJECT}
                                    value={MasterValue.projectNm}
                                    onChange={HandleMasterValue}
                                />
                            </td>
                            <td>
                                <SearchableSelect
                                    name="mbrNo"
                                    // value={inputs?.mbrNo}
                                    search={true}
                                    options={MasterOPTS.MBRNO}
                                    value={MasterValue.mbrNo}
                                    onChange={HandleMasterValue}
                                />
                            </td>
                            <td>
                                <input type="hidden" id="processCd" />
                                <SearchableSelect
                                    name="processCd"
                                    search={false}
                                    options={[
                                        { label: "USP", value: "USP" },
                                        { label: "DSP", value: "DSP" },
                                    ]}
                                    value={MasterValue.processCd}
                                    onChange={HandleMasterValue}
                                />
                            </td>
                            <td style={{ backgroundColor: "#DDD" }}>{data?.unitNm}</td>
                            <td style={{ backgroundColor: "#DDD" }}>{data?.description}</td>
                            <td style={{ backgroundColor: "#DDD", textAlign: "right" }}>
                                {data?.cycle}
                            </td>
                            {/* <td style={{ backgroundColor: "#DDD" }}>{data?.stage}</td> */}
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

const memo = (prev, next) => {
    return prev.data === next.data;
};

export default React.memo(Master, memo);

